import { CompareReducer } from '../interfaces'
import * as types from '../types'

export const initialState: CompareReducer = {
  isDrawerOpen: true,
  vehicles: [],
}

export default (state: CompareReducer = initialState, action: any) => {
  switch (action.type) {
    case types.COMPARE_OPEN:
      return { ...state, isDrawerOpen: true }
    case types.COMPARE_CLOSE:
      return { ...state, isDrawerOpen: false }
    case types.COMPARE_ADD:
      return { ...state, vehicles: [...state.vehicles, action.payload] }
    case types.COMPARE_REMOVE:
      return { ...state, vehicles: state.vehicles.filter((vehicle) => vehicle.id !== action.payload) }
    default:
      return { ...state }
  }
}
